var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeAsiaAustralia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6247 12.375C24.246 12.375 24.7497 12.8787 24.7497 13.5C24.7497 15.1802 24.0116 16.6894 22.8457 17.7185C22.3798 18.1296 21.6689 18.0853 21.2578 17.6194C20.8466 17.1536 20.8909 16.4427 21.3568 16.0315C22.0593 15.4115 22.4997 14.5079 22.4997 13.5C22.4997 12.8787 23.0033 12.375 23.6247 12.375Z",
    fill: "url(#paint0_linear_6864_8924)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3.375C9.92283 3.375 3.375 9.92283 3.375 18C3.375 26.0772 9.92283 32.625 18 32.625C26.0772 32.625 32.625 26.0772 32.625 18C32.625 9.92283 26.0772 3.375 18 3.375ZM6.86235 23.4003C8.86793 27.529 13.1016 30.375 18 30.375C18.9934 30.375 19.9594 30.2579 20.8851 30.0369C20.4546 28.8905 19.3565 28.125 18.1242 28.125C17.4034 28.125 16.7881 27.6038 16.6696 26.8928L16.5602 26.2361C16.4191 25.3895 16.9359 24.5719 17.7611 24.3361L19.2442 23.9124C19.8851 23.7293 20.4197 23.2856 20.7178 22.6894L20.7725 22.5799C21.1418 21.8415 21.8965 21.375 22.7221 21.375C23.3002 21.375 23.8546 21.6046 24.2634 22.0134L24.75 22.5H25.6924C26.9503 22.5 28.086 23.197 28.6662 24.2786C29.752 22.438 30.375 20.2917 30.375 18C30.375 11.5527 25.4446 6.25698 19.1485 5.67758C19.2149 6.07204 19.4202 6.4335 19.7322 6.69349L21.3351 8.02925C21.9976 8.58134 22.1372 9.54413 21.6589 10.2617L20.8923 11.4115C20.476 12.036 19.8634 12.5039 19.1514 12.7412L18.9381 12.8123C17.8991 13.1586 17.4738 14.3982 18.0813 15.3094C18.6355 16.1407 18.3357 17.2697 17.4421 17.7165L13.5 19.6875L14.1351 21.2752C14.412 21.9675 14.112 22.7565 13.4451 23.0899C12.8254 23.3998 12.0728 23.2221 11.6571 22.6678L10.6383 21.3093C9.88558 20.3058 8.33992 20.4452 7.77891 21.5672L6.86235 23.4003Z",
    fill: "url(#paint1_linear_6864_8924)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6864_8924",
    x1: 18,
    y1: 3.375,
    x2: 18,
    y2: 32.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6864_8924",
    x1: 18,
    y1: 3.375,
    x2: 18,
    y2: 32.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeAsiaAustralia);
export default __webpack_public_path__ + "static/media/globe-asia-australia.2b3f2e06302668bc67efc9fca712cd37.svg";
export { ForwardRef as ReactComponent };